export const isITPS3Endpoint = (endpoint: string) => endpoint === '/itp/';
